<template>
    <div>
        <div class="w-100 h-100">
            <Nav :rolname="rolname" />
        </div>
        <div class="content">
            <Home v-if="page == 'home'" @mtdChangePage="mtdChangePage" @mtdBackCampus="mtdBackCampus" />
            <StaffView v-if="page == 'personal'" @mtdChangePage="mtdChangePage" />
            <PayrollView v-if="page == 'planilla'" @mtdChangePage="mtdChangePage" />
            <ScheduleView v-if="page == 'horario'" @mtdChangePage="mtdChangePage" />
            <ContractView v-if="page == 'contrato'" @mtdChangePage="mtdChangePage" />
            <VacationsView v-if="page == 'vacaciones'" @mtdChangePage="mtdChangePage" />
            <MaintenanceView v-if="page == 'mantenimiento'" @mtdChangePage="mtdChangePage" />
        </div>
        <div class="footer">
            <Footer @mtdChangePage="mtdChangePage" :pageView="page" />
        </div>
    </div>
</template>


<script>
import Nav from '../../components/Asistencial/Nav.vue';
import StaffView from '@/components/Personal/Pages/Staff.vue';
import PayrollView from '@/components/Personal/Pages/Payroll.vue';
import ScheduleView from '@/components/Personal/Pages/Schedule.vue';
import ContractView from '@/components/Personal/Pages/Contract.vue';
import VacationsView from '@/components/Personal/Pages/Vacations.vue';
import Home from '@/components/Personal/Home.vue'
import Footer from '@/components/Personal/Footer.vue'
import MaintenanceView from '@/components/Personal/Pages/Maintenance.vue';

export default {
    name: "v-Medico",
    components: {
        Nav,
        Home,
        Footer,
        StaffView,
        PayrollView,
        ScheduleView,
        ContractView,
        VacationsView,
        MaintenanceView
    },
    data() {
        return {
            page: "home",
            rol_name: null,
        };
    },
    props: {
        rolname: String,
        dataRoles: Array,
    },
    methods: {
        changePage: function (page) {
            this.page = page;
        },
        returnHome: function () {
            this.page = "home";
        },
        mtdBackCampus: function () {
            this.$emit("mtdBackCampus");
        },
        mtdChangePage: function (page) {
            this.page = page;
        },
    },
}
</script>